import "Areas/WorkSpaces/routesMap";
import "Areas/Projects/routesMap";
import "Areas/Documents/routesMap";
import "Areas/SummaryReports/routesMap";
import "Areas/Settings/routesMap";
import "Areas/About/routesMap";
import "Areas/Error/routesMap";
